import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useSEO from "@/hooks/useSEO";

const sections = [
  {
    title: "1. 個人情報の収集について",
    content: "当社は、お問い合わせフォームやサービス申込みの際に、お名前、メールアドレス、電話番号、会社名等の個人情報をご提供いただく場合があります。これらの情報は、お客様の同意のもとに収集いたします。",
  },
  {
    title: "2. 個人情報の利用目的",
    content: "収集した個人情報は、以下の目的のために利用いたします。\n・お問い合わせへの回答および対応\n・サービスのご提案・ご案内\n・契約の締結および履行\n・サービス改善のための分析\n・法令に基づく対応",
  },
  {
    title: "3. 個人情報の第三者提供",
    content: "当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。\n・お客様の同意がある場合\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要な場合",
  },
  {
    title: "4. 個人情報の管理",
    content: "当社は、個人情報の漏洩、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業者に対して、必要かつ適切な監督を行います。",
  },
  {
    title: "5. 個人情報の開示・訂正・削除",
    content: "お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除を請求することができます。ご請求の際は、本ページ末尾の連絡先までお問い合わせください。",
  },
  {
    title: "6. Cookieの使用について",
    content: "当社ウェブサイトでは、サービス向上のためにCookieを使用する場合があります。ブラウザの設定によりCookieを無効にすることができますが、一部のサービスが利用できなくなる場合があります。",
  },
  {
    title: "7. プライバシーポリシーの変更",
    content: "当社は、法令の変更やサービス内容の変更に伴い、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。",
  },
  {
    title: "8. お問い合わせ",
    content: "個人情報の取り扱いに関するお問い合わせは、以下の連絡先までお願いいたします。\n\nStream Solutions Limited\n電話：+852-5321-3455\n所在地：Room D, Rm4. 2/F, Sunray Industrial Centre, 610 Cha Kwo Ling Road, Yau Tong, KL.",
  },
];

const PrivacyPage = () => {
  useSEO({
    title: "プライバシーポリシー | 個人情報の取り扱いについて",
    description: "Stream Solutions Limitedのプライバシーポリシー。個人情報の収集・利用目的・第三者提供・管理・開示請求について定めています。",
    keywords: "プライバシーポリシー,個人情報保護,Stream Solutions Limited",
    canonical: "/privacy",
    ogTitle: "プライバシーポリシー | Stream Solutions Limited",
    ogDescription: "Stream Solutions Limitedの個人情報の取り扱いに関するポリシーです。",
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-slate-950">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-8 h-px bg-cyan-500" />
            <span className="text-cyan-400 text-xs font-semibold tracking-[0.3em] uppercase">PRIVACY</span>
            <span className="w-8 h-px bg-cyan-500" />
          </div>
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">プライバシーポリシー</h1>
          <p className="text-slate-400 text-sm">最終更新日：2024年1月1日</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <div className="mb-10 p-6 rounded-2xl bg-cyan-50 border border-cyan-100">
            <p className="text-slate-700 text-sm leading-relaxed">
              Stream Solutions Limited（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、個人情報の保護に関する法律（個人情報保護法）および関連法令を遵守し、以下のプライバシーポリシーに従って個人情報を適切に取り扱います。
            </p>
          </div>

          <div className="space-y-10">
            {sections.map((sec) => (
              <div key={sec.title}>
                <h4 className="text-base font-bold text-slate-900 mb-4">
                  <a id={sec.title} className="scroll-mt-24">{sec.title}</a>
                </h4>
                <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-line">{sec.content}</p>
                <div className="mt-6 h-px bg-slate-100" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
